import React from "react";
import {DayPhase} from "./DayPhase";
import {GameHeader} from "../common/GameHeader";

export function Day() {
    return (<>
        <GameHeader/>
        <DayPhase/>
    </>)
}